// API client for affaire settings and responsables management
import { apiClient } from '@/core/api/client';
import type {
  AffaireSettingsResponse,
  ResponsableHistoryResponse,
  EligibleResponsablesResponse,
  ChangeResponsableRequest,
  ChangeResponsableResponse,
} from '../types/tracker.types';

/**
 * Get affaire settings including all responsables
 */
export const getAffaireSettings = async (
  affaireId: number
): Promise<AffaireSettingsResponse> => {
  return apiClient.get<AffaireSettingsResponse>(`/api/tracker/affaires/${affaireId}/settings`);
};

/**
 * Get full history of responsable changes for an affaire
 */
export const getResponsableHistory = async (
  affaireId: number
): Promise<ResponsableHistoryResponse> => {
  return apiClient.get<ResponsableHistoryResponse>(`/api/tracker/affaires/${affaireId}/responsable-history`);
};

/**
 * Get list of users eligible to be primary responsable (bureau/admin only)
 */
export const getEligibleResponsables = async (): Promise<EligibleResponsablesResponse> => {
  return apiClient.get<EligibleResponsablesResponse>('/api/tracker/affaires/eligible-responsables');
};

/**
 * Change primary responsable for an affaire
 */
export const changePrimaryResponsable = async (
  affaireId: number,
  request: ChangeResponsableRequest
): Promise<ChangeResponsableResponse> => {
  return apiClient.put<ChangeResponsableResponse>(
    `/api/tracker/affaires/${affaireId}/responsable`,
    request
  );
};
